import React from "react";
import { getLayout } from "components/layouts/LayoutEmpty";
import { LayoutLegals } from "components/layouts/LayoutLegals";
import { fetchLegalArticles, fetchLegalMenu } from "services/contentful";
import { LegalArticle } from "components/templates/LegalArticle/index";
import { ILegalArticle, ILegalMenu } from "interfaces/legal-guide-interfaces";
import { NextSeo } from "next-seo";

interface ILegalPageIndexProps {
  legalMenu: ILegalMenu;
  legalArticles: ILegalArticle[];
}

export default function LegalPageIndex({
  legalMenu,
  legalArticles,
}: ILegalPageIndexProps) {
  return (
    <>
      <NextSeo title={`LeadPro – Legal`} />
      <LayoutLegals menu={legalMenu}>
        {legalArticles && <LegalArticle article={legalArticles[0]} />}
      </LayoutLegals>
    </>
  );
}

LegalPageIndex.getLayout = getLayout;

export async function getServerSideProps() {
  const legalArticles = await fetchLegalArticles();
  const legalMenu = await fetchLegalMenu("default");

  return {
    props: {
      legalArticles: legalArticles.data,
      legalMenu: legalMenu.data,
    },
  };
}
